import badgeDark from '../assets/brand/mgl-badge-dark.svg';
import FrameShell from './FrameShell';

/* The hero visual: the real LinksOS owner dashboard, recreated faithfully
   from the live portal (the morning view, sample data). HTML instead of a
   screenshot so it stays crisp at every size and matches the brand type. */

const NAV = [
  ['Dashboard', true],
  ['Tee Sheet', false],
  ['Rates & Pricing', false],
  ['Flash Deals', false],
  ['Reporting & Analytics', false],
];

const KPIS = [
  ['Tee sheet', '31%', 'full · 55 booked, 21 open'],
  ['Booked today', '95', 'golfers across 55 tee times'],
  ['Booked value', '$4,610', 'settles at the counter'],
];

const NEXT_UP = [
  ['09:08 AM', '3 golfers', '3 spots'],
  ['09:16 AM', '1 golfer', '1 spot'],
  ['09:24 AM', '2 golfers', '2 spots'],
];

export default function PortalFrame() {
  return (
    <FrameShell>
      <div className="pf-grid">
        <div className="pf-side on-pine" style={{ background: 'var(--pine-deep)', padding: '14px 10px' }}>
          <img src={badgeDark} alt="" width="92" height="35" style={{ display: 'block', margin: '2px 4px 2px' }} />
          <div className="mono" style={{ fontSize: 8, letterSpacing: '0.22em', color: 'var(--gold-bright)', margin: '0 6px 12px' }}>
            LINKSOS+
          </div>
          <div className="mono" style={{ fontSize: 7.5, letterSpacing: '0.18em', color: 'var(--cream-faint)', margin: '0 6px 6px' }}>
            MGL DEMO COURSE
          </div>
          {NAV.map(([label, active]) => (
            <div
              key={label}
              style={{
                fontSize: 10.5, fontWeight: active ? 700 : 500, padding: '6px 8px', borderRadius: 6,
                color: active ? 'var(--cream)' : 'var(--cream-faint)',
                background: active ? 'rgba(243,240,228,0.12)' : 'transparent',
              }}
            >
              {label}
            </div>
          ))}
        </div>

        <div style={{ padding: '16px 18px 18px' }}>
          <div className="mono" style={{ fontSize: 9, letterSpacing: '0.1em', color: 'var(--faint)' }}>
            FRIDAY, AUGUST 7
          </div>
          <div style={{ fontSize: '1.22rem', fontWeight: 750, letterSpacing: '-0.02em', margin: '3px 0 1px' }}>
            Good morning, Owner
          </div>
          <div style={{ fontSize: 10.5, color: 'var(--mut)', marginBottom: 13 }}>MGL Demo Course</div>

          <div className="pf-kpis">
            {KPIS.map(([label, big, sub]) => (
              <div key={label} style={{ background: 'var(--card)', border: '1px solid var(--line-soft)', borderRadius: 9, padding: '9px 11px' }}>
                <div style={{ fontSize: 8.5, fontWeight: 650, color: 'var(--mut)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{label}</div>
                <div className="mono" style={{ fontSize: '1.05rem', fontWeight: 600, margin: '2px 0 1px' }}>{big}</div>
                <div style={{ fontSize: 8.5, color: 'var(--faint)' }}>{sub}</div>
              </div>
            ))}
          </div>

          <div style={{ fontSize: 9.5, fontWeight: 700, color: 'var(--mut)', marginBottom: 6 }}>Next up</div>
          <div style={{ display: 'grid', gap: 5 }}>
            {NEXT_UP.map(([t, who, spots]) => (
              <div key={t} style={{ display: 'flex', alignItems: 'center', gap: 10, background: 'var(--card)', border: '1px solid var(--line-soft)', borderRadius: 7, padding: '6px 11px' }}>
                <span className="mono" style={{ fontSize: 10, fontWeight: 600 }}>{t}</span>
                <span style={{ fontSize: 10, color: 'var(--mut)' }}>{who}</span>
                <span className="mono" style={{ marginLeft: 'auto', fontSize: 8.5, fontWeight: 600, color: 'var(--fairway)', border: '1px solid rgba(47,107,76,0.35)', borderRadius: 5, padding: '2px 7px' }}>
                  {spots}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </FrameShell>
  );
}
